import { WorldProvider } from "./use-world";
import { Character } from "./character";
import { Clock } from "./clock";
import { Player } from "./player";
import { Terminal } from "./terminal";
import { getRandomInt } from "utils";
import { useLocalStorage } from "hooks";
import styled from "styled-components";
import mapData from "./map.json";
import { Map } from "./map";

const Board = styled.div`
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
`;

export const BarflyBoard = () => {
  const [data] = useLocalStorage("barfly", mapData);
  return (
    <Board>
      <Map data={data}>
        <Character
          x={getRandomInt(200)}
          y={getRandomInt(100)}
          image="/Sprites/Hula_0001.png"
          backgroundColor="#42C"
          config={{
            id: "Leilani",
            npc: true,
          }}
        />
        <Character
          x={getRandomInt(200)}
          y={getRandomInt(100)}
          image="/Sprites/Sailor_0001.png"
          backgroundColor="#B2A"
          config={{
            id: "Popeye",
            npc: true,
          }}
        />
        <Character
          x={getRandomInt(200)}
          y={getRandomInt(100)}
          image="/Sprites/Cowgirl_0001.png"
          backgroundColor="#DF1"
          config={{
            id: "Bobbie Jo",
            npc: true,
          }}
        />
        <Player
          x={50}
          y={50}
          image="/Sprites/AnnieNika/Annie.Nika_0001.png"
          backgroundColor="#CCC"
          config={{
            id: "player",
          }}
        />
      </Map>
      <Clock />
      <Terminal />
    </Board>
  );
};

export const Barfly = () => {
  return (
    <WorldProvider>
      <BarflyBoard />
    </WorldProvider>
  );
};
